
  import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
  import EmployeeCardAvatar from "@/components/employee/EmployeeCardAvatar.vue";
  import getFullName from "@/helpers/getFullName";
  import UiButton from "@/components/button/ui-button.vue";
  import RouteParams from "@/entities/RouteParams";
  import ChipStatus from "@/entities/ChipStatus";
  import StatusChip from "@/components/icons/StatusChip.vue";
  import EmployeeCardUserName from "@/components/employee/EmployeeCardUserName.vue";
  import CardContainer from "@/components/card/CardContainer.vue";
  import ContainerSize from "@/components/uiSize/ContainerSize.vue";
  import { getLocationOrPlaceholder } from "@/helpers/locations/getLocationInfo";

  @Component({
    components: {
      ContainerSize,
      CardContainer,
      EmployeeCardUserName,
      StatusChip,
      UiButton,
      EmployeeCardAvatar,
    },
  })
  export default class EmployeeCard extends Vue {
    @Prop({ type: Object, required: true }) readonly employeePageRouteParams!: RouteParams<{ id: string }>;
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly employeeUserId!: string;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;
    @Prop({ type: Boolean, default: false }) readonly available!: boolean;
    @Prop({ type: String, default: undefined }) readonly country?: string;
    @Prop({ type: String, default: undefined }) readonly city?: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: Number, default: undefined }) readonly nameBlockMinHeight?: number;
    @PropSync('nameBlockMinHeight', { type: Number, default: undefined }) nameBlockMinHeightValue?: number

    get status(): ChipStatus {
      if (this.available) {
        return ChipStatus.ATTENTION;
      }

      return ChipStatus.INFO;
    }

    get fullName(): string {
      return getFullName(this.givenName, this.familyName);
    }

    openEmployeePage(): void {
      this.$router.push(this.employeePageRouteParams);
    }

    message(): void {
      this.$router.push({
        name: "inbox",
        query: {
          recipientUserId: this.employeeUserId,
        },
      });
    }

    get location(): string {
      return getLocationOrPlaceholder([this.city, this.country]);
    }
  }
